const PROJECT_PACKAGE_PRICING_DEFAULT = {
  id: '',
  projectID: '',
  name: '',
  description: '',
  orderPriority: 0,
  bumiPurchaserOnly: false,
  isEnabled: true,
  // CPI-977: the Vietnam deposit rate, a FRACTION of the nett price (0.1000 = 10%). null means the
  // package has no rate, and the project's flat reservation sum still applies -- which is every
  // Malaysian and Indonesian package, and the state a new package starts in.
  depositRate: null,
  scheduleStartAt: null,
  scheduleEndAt: null,
  // TODO: change to packagePricingCalculations
  packagePricingItems: [],
  businessUnitAccesses: [],
  createdAt: null,
  updatedAt: null,
};

const PROJECT_PACKAGE_PRICING_ITEM_DEFAULT = {
  id: '',
  projectPackagePricingID: '',
  name: '',
  description: '',
  orderPriority: 0,
  isEnabled: true,
  formulaType: 'discount_percent_original_price',
  formulaValue: '',
  newValue: 0,
  valueChange: 0,
  createdAt: null,
  updatedAt: null,
};

const PROJECT_UNIT_PACKAGE_PRICING_DEFAULT = {
  id: '',
  projectID: '',
  projectUnitID: '',
  projectPackagePricingID: '',
  orderPriority: 0,
  totalPrice: '',
  isCustomPrice: false,
  customName: '',
  customDescription: '',
  createdAt: null,
  updatedAt: null,
  accessibleIn: [],
};

export {
  PROJECT_PACKAGE_PRICING_DEFAULT,
  PROJECT_PACKAGE_PRICING_ITEM_DEFAULT,
  PROJECT_UNIT_PACKAGE_PRICING_DEFAULT,
};



// WEBPACK FOOTER //
// ./src/structs/package_pricing.js